import { jsx } from 'react/jsx-runtime';

/** ![alignRightIcon](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMiI+PHJlY3QgZmlsbD0iI2ZmZiIgc3Ryb2tlPSIjZmZmIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiLz48cGF0aCBkPSJNMjEgNkgzTTIxIDEySDlNMjEgMThINyIvPjwvc3ZnPg==) */
const alignRightIcon = /*#__PURE__*/jsx("path", {
  d: "M21 6H3M21 12H9M21 18H7"
});

export { alignRightIcon };
